/**
 * Layout simplificado para usuarios con rol 'player' (futbolistas)
 *
 * Solo maneja:
 * - Carga de datos del jugador
 * - Contexto compartido para las páginas hijas
 * - El header y navegación se manejan en App.js
 */

import { useState, useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

const PlayerLayout = () => {
  const [playerData, setPlayerData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Memoizar el contexto para evitar re-renderizados innecesarios
  const contextValue = useMemo(() => ({
    playerData,
    setPlayerData
  }), [playerData]);

  // Cargar datos del jugador
  useEffect(() => {
    const fetchPlayerData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('prokids_token');

        const response = await fetch('/api/player/dashboard', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const result = await response.json();
          if (result.success) {
            setPlayerData(result.data);
          }
        } else {
          console.error('❌ Error en la respuesta:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error al cargar datos del jugador:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlayerData();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        backgroundColor: '#F5F5F5'
      }}>
        <div style={{
          textAlign: 'center',
          color: '#4352A9'
        }}>
          <div style={{
            fontSize: '2rem',
            marginBottom: '10px'
          }}>⚽</div>
          <p>Cargando datos del jugador...</p>
        </div>
      </div>
    );
  }

  return <Outlet context={contextValue} />;
};

export default PlayerLayout;
